import { SiteConfigActionTypes, SiteConfigActions } from './types';
import { SiteConfig } from '../../models/SiteConfig';

const initialState: SiteConfig = {
  pageTitle: '',
};

const siteConfigReducers = (state = initialState, action: SiteConfigActions) => {
  switch (action.type) {
    case SiteConfigActionTypes.ACTION_SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.payload.pageTitle,
      };
  }
  return state;
};

export default siteConfigReducers;